import React from 'react';
import { Link } from 'react-router-dom';

interface DashboardItemProps {
  to: string;
  title: string;
  icon?: string;
}

export function DashboardContainer(props: React.PropsWithChildren<{ title: string }>) {
  return (
    <div style={{ marginBottom: 20 }}>
      <h5 style={{ marginBottom: 20 }}>{props.title}</h5>
      <div className="dashboard">{props.children}</div>
    </div>
  );
}

export function DashboardBigItem(props: DashboardItemProps) {
  return (
    <Link to={props.to} className="dashboard-entry big">
      {props.icon && <i className={props.icon} />}
      <span>{props.title}</span>
    </Link>
  );
}

export function DashboardSmallItem(props: DashboardItemProps) {
  return (
    <Link to={props.to} className="dashboard-entry small">
      {props.icon && <i className={props.icon} />}
      <span>{props.title}</span>
    </Link>
  );
}
